import React from 'react';

export const InboxContext = React.createContext({});

export const InboxProvider = ({ children }) => {
  const [inboxMessages, setInboxMessages] = React.useState(null);
  const value = {
    inboxMessages,
    setInboxMessages,
  };
  return (
    <InboxContext.Provider value={value}>{children}</InboxContext.Provider>
  );
};
